export const POSTAL_CODE_VERIFIED = 'POSTAL_CODE_VERIFIED';
export const SET_DELIVERY_METHOD = 'SET_DELIVERY_METHOD';
export const SET_POSTAL_CODE = 'SET_POSTAL_CODE';
export const SET_DATE = 'SET_DATE';
export const SET_START_TIME = 'SET_START_TIME';
export const SET_END_TIME = 'SET_END_TIME';
